import { RadioGroup } from 'informed';
import PropTypes from 'prop-types';
import React from 'react';

const ToggleBase = ({ children, className, disabled, humanName, id }) => {
  const childrenWithId = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      groupId: id,
    });
  });
  return (
    <fieldset className={className} disabled={disabled}>
      <legend className="sr-only">{humanName}</legend>
      <RadioGroup disabled={disabled} field={id}>
        {childrenWithId}
      </RadioGroup>
    </fieldset>
  );
};

ToggleBase.defaultProps = {
  className: '',
  disabled: false,
};

ToggleBase.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  humanName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default ToggleBase;
